import * as React from 'react';

import { ChevronLeftIcon } from '../../icons';
import { cx } from '../../utils/cx';

import Button from './Button';

interface ICollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const CollapseButton = ({ isCollapsed, onToggle }: ICollapseButtonProps) => {
  const ChevronIcon = React.useMemo(
    () => (
      <ChevronLeftIcon
        data-icon="leading"
        className={cx(
          'pointer-events-none size-5 shrink-0 transition-transform duration-200',
          !isCollapsed && 'rotate-90'
        )}
      />
    ),
    [isCollapsed]
  );

  return (
    <Button
      iconLeading={ChevronIcon}
      size="sm"
      color="tertiary"
      className="p-1.5"
      aria-label={isCollapsed ? 'Expand' : 'Collapse'}
      onClick={onToggle}
    />
  );
};

export default CollapseButton;
